const ZDANIA68 = [
  {
    name: "[6 klasa] Niem Czerwiec 2024",
    lang: 'de',
    zdania: [
      {
        pl: "Tato, musisz podpisać moje świadectwo",
        de: "Vati, du musst mein Zeugnis unterschreiben",
      },
      {
        pl: "Co? Znowu piątka z matematyki?",
        de: "Was? Schon wieder eine Fünf in Mathe?",
      },
      {
        pl: "Już sama podróż do Anglii lub Francji jest przeżyciem",
        de: "Schon die Reise nach England oder Frankreich ist ein Erlebnis",
      },
      {
        pl: "Podczas podróży poznasz innych uczestników kursu",
        de: "Während der Fahrt lernst du die anderen Kursteilnehmer kennen",
      },
      {
        pl: "Na pewno będziesz się z nimi dobrze bawić",
        de: "Du wirst sicher viel Spaß mit ihnen haben",
      },
      {
        pl: "Twój instruktor zawsze będzie przy tobie",
        de: "Dein Kursleiter ist immer dabei",
      },
      {
        pl: "Opiekuje się tobą i twoją grupą",
        de: "Er betreut dich und deine Gruppe",
      },
      {
        pl: "Czy zdecydowałeś się na podróż do Anglii?",
        de: "Hast du dich für eine Reise nach England entschieden?",
      },
      {
        pl: "W takim razie polecisz samolotem do Londynu",
        de: "Dann geht es mit dem Flugzeug nach London",
      },
      {
        pl: "Stamtąd dalej autobusem",
        de: "Von hier dann weiter mit dem Bus",
      },
      {
        pl: "Do Francji natomiast pojedziesz pociągiem",
        de: "Nach Frankreich geht es dagegen mit der Bahn",
      },
      {
        pl: "Dojedziesz bezpośrednio do miejsca docelowego",
        de: "Du kommst direkt an deinem Zielort an",
      },
      {
        pl: "Twoja rodzina goszcząca będzie tam na ciebie czekać",
        de: "Deine Gastfamilie erwartet dich dort",
      },
      {
        pl: "Będziesz mieszkać u rodziny goszczącej",
        de: "Du wirst bei einer Gastfamilie wohnen",
      },
      {
        pl: "Wszystkie rodziny są miłe, przyjazne i otwarte",
        de: "Alle Familien sind nett, freundlich und aufgeschlossen",
      },
      {
        pl: "U rodziny goszczącej będziesz brać udział w codziennym życiu",
        de: "In einer Gastfamilie nimmst du am täglichen Leben teil",
      },
      {
        pl: "Poznajesz w ten sposób ludzi, tradycje i inną kulturę",
        de: "Du lernst so Menschen, Traditionen und eine andere Kultur kennen",
      },
      {
        pl: "Wybieramy tylko takie rodziny goszczące",
        de: "Wir suchen nur Gastfamilien aus",
      },
      {
        pl: "One naprawdę interesują się",
        de: "Sie haben wirklich Interesse",
      },
      {
        pl: "Chcą poznać młodych ludzi z innych krajów",
        de: "Sie wollen junge Leute aus anderen Ländern kennenlernen",
      },
      {
        pl: "Zazwyczaj mieszkasz z innym uczestnikiem kursu",
        de: "In der Regel wohnst du mit einem anderen Teilnehmer deines Kurses",
      },
      {
        pl: "Mieszkasz u swojej rodziny goszczącej",
        de: "Du wohnst bei deiner Gastfamilie",
      },
      {
        pl: "Jeśli wolisz mieszkać samemu w rodzinie, jest to również możliwe",
        de: "Wenn du lieber allein in einer Familie wohnen möchtest, ist das ebenfalls möglich",
      },
      {
        pl: "Zajęcia odbywają się codziennie od poniedziałku do piątku",
        de: "Unterricht findet jeden Tag von Montag bis Freitag statt",
      },
      {
        pl: "Zajęcia są w godzinach od 9.00 do 12.00",
        de: "Der Unterricht ist in der Zeit von 9.00-12.00 Uhr",
      },
      {
        pl: "Aby zajęcia były jak najbardziej efektywne, grupy są małe",
        de: "Um den Unterricht so effizient wie möglich zu gestalten, sind die Gruppen klein",
      },
      {
        pl: "Grupy mają 10-12 uczestników",
        de: "Die Gruppen haben 10-12 Teilnehmer",
      },
      {
        pl: "Głównym celem jest większa pewność siebie w swobodnym mówieniu",
        de: "Größere Sicherheit beim freien Sprechen ist das Hauptziel",
      },
      {
        pl: "Będziesz więc dużo konwersować ze swoimi nauczycielami",
        de: "Du wirst also mit deinen Lehrern viel Konversation machen",
      },
      {
        pl: "Również słownictwo i wymowa mają zostać poprawione",
        de: "Das Vokabular und die Aussprache sollen auch verbessert werden",
      },
      {
        pl: "Na koniec kursu każdy uczestnik otrzymuje certyfikat",
        de: "Am Ende des Kurses erhält jeder Teilnehmer ein Zertifikat",
      },
      {
        pl: 'Do jakich krajów Twoim zdaniem organizuje wyjazdy językowe szkoła językowa „Sonnenberg"?',
        de: 'In welche Länder organisiert deiner Meinung nach die Sprachschule „Sonnenberg" Sprachreisen?',
      },
      {
        pl: 'Jakich języków obcych możesz się uczyć w szkole językowej „Sonnenberg"?',
        de: 'Welche Fremdsprachen kannst du mit der Sprachschule „Sonnenberg" lernen?',
      },
    ],
  },
];

const ZDANIA69 = [
  {
    name: "[7 klasa] Niem Wrzesien 2024",
    lang: 'de',
    zdania: [
      {
        pl: "Chcę pojechać do Anglii, aby poprawić mój angielski",
        de: "Ich möchte nach England fahren, um mein Englisch zu verbessern",
      },
      {
        pl: "Tina jedzie do Londynu, aby zwiedzić miasto",
        de: "Tina fährt nach London, um die Stadt zu besichtigen",
      },
      {
        pl: "Tina jedzie na kurs, aby uczyć się angielskiego",
        de: "Tina fährt zum Kurs, um Englisch zu lernen",
      },
      {
        pl: "Tina musi więcej się uczyć, aby mieć dobre oceny",
        de: "Tina muss mehr lernen, um gute Noten zu haben",
      },
      {
        pl: "Aby pojechać do Paryża, musisz nauczyć się francuskiego",
        de: "Um nach Paris zu fahren, musst du Französisch lernen",
      },
      {
        pl: "Pracuję codziennie, aby mieć dobre oceny",
        de: "Ich arbeite jeden Tag, um gute Noten zu haben",
      },
      {
        pl: "Uczę się angielskiego, aby pojechać do Anglii",
        de: "Ich lerne Englisch, um nach England zu fahren",
      },
      {
        pl: "Chcę pojechać do Niemiec, aby ćwiczyć niemiecki",
        de: "Ich möchte nach Deutschland fahren, um mein Deutsch zu üben",
      },
      {
        pl: "Piotr idzie do biblioteki, aby przeczytać książkę",
        de: "Piotr geht in die Bibliothek, um ein Buch zu lesen",
      },
      {
        pl: "Musisz się uczyć, aby zdać egzamin",
        de: "Du musst lernen, um die Prüfung zu bestehen",
      },
      {
        pl: "Idę na kurs, aby poprawić swoje oceny",
        de: "Ich gehe zum Kurs, um meine Noten zu verbessern",
      },
      {
        pl: "Aby kupić nowy samochód, muszę oszczędzać pieniądze",
        de: "Um ein neues Auto zu kaufen, muss ich Geld sparen",
      },
      {
        pl: "Ona pracuje ciężko, aby dostać stypendium",
        de: "Sie arbeitet hart, um ein Stipendium zu bekommen",
      },
      {
        pl: "Chcę pojechać do Berlina, aby zwiedzić muzea",
        de: "Ich möchte nach Berlin fahren, um die Museen zu besichtigen",
      },
      // Nowe zdania dotyczące zakupów
      {
        pl: "Idę do sklepu, aby kupić nowe buty",
        de: "Ich gehe in den Laden, um neue Schuhe zu kaufen",
      },
      {
        pl: "Chcę zrobić zakupy, aby mieć wszystko na obiad",
        de: "Ich möchte einkaufen gehen, um alles für das Abendessen zu haben",
      },
      {
        pl: "Muszę iść na targ, aby kupić świeże warzywa",
        de: "Ich muss auf den Markt gehen, um frisches Gemüse zu kaufen",
      },
      // Nowe zdania dotyczące sportu
      {
        pl: "Chcę biegać, aby poprawić swoją kondycję",
        de: "Ich möchte joggen, um meine Fitness zu verbessern",
      },
      {
        pl: "Muszę trenować, aby być gotowym na zawody",
        de: "Ich muss trainieren, um für den Wettbewerb bereit zu sein",
      },
      {
        pl: "Piotr gra w piłkę nożną, aby utrzymać formę",
        de: "Piotr spielt Fußball, um fit zu bleiben",
      },
      // Nowe zdania dotyczące grania
      {
        pl: "Gram w gry komputerowe, aby się zrelaksować",
        de: "Ich spiele Computerspiele, um mich zu entspannen",
      },
      {
        pl: "Tina gra w szachy, aby poprawić swoje umiejętności",
        de: "Tina spielt Schach, um ihre Fähigkeiten zu verbessern",
      },
      {
        pl: "Gramy w piłkę, aby dobrze się bawić",
        de: "Wir spielen Fußball, um Spaß zu haben",
      },
      // Nowe zdania dotyczące wyjścia ze znajomymi
      {
        pl: "Idę na spacer ze znajomymi, aby odpoczą",
        de: "Ich gehe mit Freunden spazieren um mich zu erholen",
      },
      {
        pl: "Wychodzę z przyjaciółmi aby pójść do kina",
        de: "Ich gehe mit meinen Freunden aus um ins Kino zu gehenx",
      },
      {
        pl: "Idziemy do restauracji, aby zjeść kolację razem",
        de: "Wir gehen ins Restaurant, um zusammen Abendessen zu essen",
      },
    ],
  },
];

export { ZDANIA68, ZDANIA69 };
